export const TRANSACTION_TYPES_ASSIGNMENT_TITLE = 'Transaction type assignment';

export const TRANSACTION_TYPES_ASSIGNMENT_INFO = 'Add or remove transaction types on the transaction this rule evaluated. A rule nested under this one can then filter on those transaction types through its transaction type configuration.';
